"use client";

import Link from "next/link";
import { isGaiaiBlogProductPath } from "@/lib/blog/gaiaiIntentLinks";
import {
  getGrowthSiteContext,
  GROWTH_EVENT_NAMES,
  trackGrowthEvent,
} from "@/lib/analytics/growthAnalytics";

const BLOG_PATH = /^\/blog\/[a-z0-9]+(?:-[a-z0-9]+)*$/;
export function GaiaiBlogProductLink({
  href,
  sourcePath,
  label,
  description,
}: {
  href: string;
  sourcePath: string;
  label: string;
  description?: string | null;
}) {
  function trackNavigation() {
    const context = getGrowthSiteContext();
    if (
      context?.brand !== "gaiai" ||
      context.site_host !== "gaiai.ai" ||
      !BLOG_PATH.test(sourcePath) ||
      !isGaiaiBlogProductPath(href) ||
      window.location.pathname.replace(/\/$/, "") !== sourcePath
    )
      return;
    trackGrowthEvent(GROWTH_EVENT_NAMES.BLOG_PRODUCT_LINK_CLICK, {
      source_path: sourcePath,
      target_path: href.replace(/\/$/, ""),
      interaction_status: "navigation_only",
    });
  }

  return (
    <Link
      href={href}
      prefetch={false}
      onClick={trackNavigation}
      className="rounded-lg border border-slate-200 bg-slate-50 p-4 transition-all hover:border-teal-300 hover:bg-white hover:shadow-sm"
    >
      <div className="text-sm font-semibold text-slate-900">{label}</div>
      <p className="mt-2 text-sm text-slate-600">{description}</p>
    </Link>
  );
}
